// Shared "which playoff round is the user looking at" state, so the shell's advance bar and the
// GmPlayoffs screen agree. The bar reads it to decide "Sim {round}" vs "Continue to {next}"; the
// screen renders that round. `key` scopes a value to one playoffs run (e.g. "po-2027") so a new
// postseason resets cleanly. Kept out of the worker-synced `local` store since it's pure UI state.

import { useSyncExternalStore } from "react";

let state = { round: 0, key: "" };
const listeners = new Set<() => void>();

const getSnapshot = () => state;

const subscribe = (listener: () => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

export const setPlayoffsRound = (round: number, key: string) => {
	if (state.round === round && state.key === key) {
		return;
	}
	state = { round, key };
	for (const listener of listeners) {
		listener();
	}
};

export const usePlayoffsRound = () =>
	useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
